export default __webpack_public_path__ + "static/media/icon-others-leave.beb8f256.svg";